import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import AddProductForm from "./AddProductForm";
import axios from "axios";
import HeaderSection from "./HeaderSection";

const UpdateProductPage = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [editingProduct, setEditingProduct] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);  // Search results
  const [country, setCountry] = useState("India"); // Default to India
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [loading, setLoading] = useState(false);

  const indianBtnRef = useRef(null);
  const saudiBtnRef = useRef(null);
  const viewAllBtnRef = useRef(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    setFilteredProducts(products); // Initially, display all products
  }, [products]); // Update when products change

  const fetchProducts = async (category = "", state = "") => {
    setLoading(true);
    try {
      const res = await axios.get(`https://enzo-matr.onrender.com/api/products`);
      let filteredData = res.data;

      // Apply category filter if selected
      if (category) {
        filteredData = filteredData.filter(product => product.category === category);
      }

      // Apply state (country) filter if selected
      if (state) {
        filteredData = filteredData.filter(product => product.state === state);
      }

      setProducts(filteredData);
      setFilteredProducts(filteredData);
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteProductId(id);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    axios.delete(`https://enzo-matr.onrender.com/api/products/${deleteProductId}`) // Corrected endpoint
      .then(() => {
        fetchProducts(); // Refresh the product list after deletion
        setDeleteDialogOpen(false);
      })
      .catch((err) => console.log(err));
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };

  const handleFilterByCountry = (state) => {
    setSelectedState(state);
    fetchProducts(selectedCategory, state); // Apply both filters
  };

  const handleSearch = () => {
    const query = search.toLowerCase().trim();
    if (!query) {
      setFilteredProducts(products);
      return;
    }

    const filtered = products.filter((product) =>
      product.name.toLowerCase().includes(query) ||
      product.company.toLowerCase().includes(query) ||
      product.price.toString().includes(query) ||
      product.discount.toString().includes(query) ||
      product.vat.toString().includes(query) ||
      product.date.toLowerCase().includes(query)
    );
    setFilteredProducts(filtered);
  };

  // Add this function inside your component
  const handleSearchBarKeyDown = (e) => {
    if (e.key === "ArrowRight") {
      indianBtnRef.current && indianBtnRef.current.focus();
    }
    if (e.key === "ArrowLeft") {
      viewAllBtnRef.current && viewAllBtnRef.current.focus();
    }
  };

  return (
    <>
      <HeaderSection />
      <Box sx={{ bgcolor: "#20a4a3", p: 1, textAlign: "center", marginBottom: "0px", marginTop: "-9px" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "white", fontFamily: "caladea" }}>
          UPDATE PRODUCT
        </Typography>
      </Box>
      <Box
        sx={{
          p: { xs: 1, sm: 2, md: 4 },
          backgroundColor: "#f9f9f9",
          minHeight: "88%",
          minWidth: "88%",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "98%", md: "68%" },
            height: { xs: "auto", md: "443px" },
            backgroundColor: "white",
            margin: { xs: "0 auto", md: "0 auto" },
            p: { xs: 1, sm: 2, md: 4 },
            borderRadius: 2,
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
            marginLeft: { xs: 0, md: "-20px" },
            marginTop: { xs: 0, md: "-20px" },
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Grid
            container
            spacing={0.5}
            alignItems="center"
            sx={{
              marginBottom: "5px",
            
              background: "#f8f9fa",
              borderRadius: "10px",
              flexWrap: "wrap",
            }}
          >
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                placeholder="Search Item"
                size="small"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  if (e.target.value === "") {
                    setFilteredProducts(products); // Clear filter when input is empty
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                  handleSearchBarKeyDown(e); // <-- Add this line
                }}
                InputProps={{
                  sx: { borderRadius: "10px",width: { xs: "100%", sm: "240px", md: "330px" }, border: "1px solid black", background: "white" },
                  endAdornment: (
                    <IconButton onClick={handleSearch} sx={{ color: "black" }}>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                ref={indianBtnRef}
                variant="contained"
                color="primary"
                sx={{
                  background: "#25bdbe",
                  color: "black",
                  border: "1px solid",
                  borderRadius: "10px",
                  fontFamily: "source serif pro",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  width: "100%",
                  ml: { xs: 0, sm: 1 },
                  mt: { xs: 1, sm: 0 },
                }}
                onClick={() => handleFilterByCountry("India")}
                onKeyDown={(e) => {
                  if (e.key === "ArrowRight") {
                    saudiBtnRef.current && saudiBtnRef.current.focus();
                  }
                  if (e.key === "ArrowLeft") {
                    // Go back to search bar
                    document.querySelector('input[placeholder="Search Item"]')?.focus();
                  }
                }}
              >
                Indian
              </Button>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                ref={saudiBtnRef}
                variant="contained"
                color="primary"
                sx={{
                  background: "#25bdbe",
                  color: "black",
                  border: "1px solid",
                  borderRadius: "10px",
                  fontFamily: "source serif pro",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  width: "100%",
                  mt: { xs: 1, sm: 0 },
                  ml: { xs: 0, sm: 1 },
                }}
                onClick={() => handleFilterByCountry("Saudi")}
                onKeyDown={(e) => {
                  if (e.key === "ArrowRight") {
                    viewAllBtnRef.current && viewAllBtnRef.current.focus();
                  }
                  if (e.key === "ArrowLeft") {
                    indianBtnRef.current && indianBtnRef.current.focus();
                  }
                }}
              >
                Saudi
              </Button>
            </Grid>
            <Grid item xs={12} sm={3.3}>
              <Button
                ref={viewAllBtnRef}
                variant="contained"
                sx={{
                  background: "#2f2f2f",
                  color: "white",
                  border: "1px solid",
                  borderRadius: "10px",
                  fontFamily: "source serif pro",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  width: { xs: "100%", sm: "230px", md: "320px" }, // Responsive width
                  ml: { xs: 0, sm: 1 },
                  mt: { xs: 1, sm: 0 },
                }}
                onClick={() => fetchProducts()}
                onKeyDown={(e) => {
                  if (e.key === "ArrowLeft") {
                    saudiBtnRef.current && saudiBtnRef.current.focus();
                  }
                  if (e.key === "ArrowRight") {
                    // Go back to search bar
                    document.querySelector('input[placeholder="Search Item"]')?.focus();
                  }
                }}
              >
                View All
              </Button>
            </Grid>
          </Grid>
          {loading ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "200px" }}>
              <CircularProgress
                size={40}
                thickness={5}
                sx={{
                  color: "#20a4a3",
                  '& .MuiCircularProgress-circle': { stroke: "#000" },
                }}
              />
              <Typography sx={{ mt: 1, color: "black", fontWeight: "bold" }}>
                Loading...
              </Typography>
            </Box>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: { xs: 250, sm: 350, md: 420 }, // Responsive height
                overflowY: "auto",
                overflowX: { xs: "auto", md: "visible" }, // Horizontal scroll on mobile
                scrollbarWidth: "none", // Firefox
                "-ms-overflow-style": "none", // IE and Edge
                "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari, Opera
                borderRadius: 2,
              }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60 }}>Image</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 90, display: { xs: "none", sm: "table-cell" } }}>Added Date</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 120 }}>Product Detail</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60 }}>Update</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60, display: { xs: "none", sm: "table-cell" } }}>Previous</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60, display: { xs: "none", sm: "table-cell" } }}>Discount</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60, display: { xs: "none", sm: "table-cell" } }}>VAT</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60, display: { xs: "none", sm: "table-cell" } }}>Price</TableCell>
                    <TableCell sx={{ color: "white", backgroundColor: "black", minWidth: 60 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredProducts.length > 0 ? (
                    filteredProducts.map((product) => (
                      <TableRow key={product._id || product.id}>
                        <TableCell>
                          <img
                            src={product.image}
                            alt=""
                            style={{ width: 36, height: 36, borderRadius: "50%", cursor: "pointer" }}
                            onClick={() => {
                              setPreviewImageSrc(product.image);
                              setImagePreviewOpen(true);
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>{product.date}</TableCell>
                        <TableCell>
                          <b style={{ fontSize: 14 }}>{product.name}</b>
                          <br />
                          <span style={{ color: "grey", fontSize: 12 }}>{product.company}</span>
                        </TableCell>
                        <TableCell sx={{ color: product.count <= product.previous ? "red" : "inherit" }}>
                          {product.count}
                        </TableCell>
                        <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>{product.previous}</TableCell>
                        <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>{product.discount}</TableCell>
                        <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>{product.vat}</TableCell>
                        <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>{product.price}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => setEditingProduct(product)}
                            sx={{
                              bgcolor: "#20a4a5",
                              color: "white",
                              borderRadius: "10px",
                              border: "2px solid black",
                              width: 36,
                              height: 36,
                              mr: 0.5,
                              "&:hover": { bgcolor: "#1a8a8a" },
                            }}
                          >
                            <FaEdit style={{ fontSize: 18 }} />
                          </IconButton>
                          <IconButton onClick={() => handleDeleteClick(product._id)}
                            sx={{
                              bgcolor: "#bb1726",
                              color: "white",
                              borderRadius: "10px",
                              border: "2px solid black",
                              width: 36,
                              height: 36,
                              "&:hover": { bgcolor: "#a01522" },
                            }}
                          >
                            <RiDeleteBin5Line style={{ fontSize: 18 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} style={{ textAlign: "center", fontSize: "16px", color: "gray" }}>
                        No matching products found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
        <AddProductForm
          editingProduct={editingProduct}
          onUpdateProduct={(updatedProduct) => {
            setEditingProduct(products.find(product => product.name === updatedProduct) || null); // Set the selected product
            setSelectedCategory(updatedProduct); // Update the selected category
            fetchProducts(updatedProduct, selectedState); // Apply both filters
          }}
        />

        <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel}>No</Button>
            <Button onClick={handleDeleteConfirm} color="error">Yes</Button>
          </DialogActions>
        </Dialog>

        {/* Image Preview Dialog */}
        <Dialog
          open={imagePreviewOpen}
          onClose={() => setImagePreviewOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: { borderRadius: "50%", background: "transparent", boxShadow: "none" }
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
              minWidth: "300px",
              borderRadius: "50%",
              p: 2,
            }}
            onClick={() => setImagePreviewOpen(false)}
          >
            <img
              src={previewImageSrc}
              alt="Preview"
              style={{
                width: "250px",
                height: "250px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "6px solid white",
                boxShadow: "0 0 24px 0 rgba(0,0,0,0.5)",
                background: "white"
              }}
            />
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default UpdateProductPage;